import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { IMaterialsSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import useGetSelectOption from 'src/hooks/useGetSelectOption';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: IMaterialsSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { t } = useTranslation();
  const methods = useForm<IMaterialsSFilter>({});
  const { getLang } = useGetSelectOption();

  // 검색 함수
  const onValid = (data: IMaterialsSFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true} cols={2}>
        <FormItem>
          <RHFSelect label={t('materials.fields.langCd.name')} name="langCd" options={getLang()} />
        </FormItem>
        <FormItem>
          <RHFTextField label={t('materials.fields.searchText.name')} name="searchText" />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
